import { defineComponent as _defineComponent } from 'vue'
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationActionButtons',
  props: {
    isAllRead: { type: [Boolean, String] },
    isNotificationsEmpty: { type: [Boolean, String] }
  },
  emits: ["mark-as-read", "see-all"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'mark-as-read'): void;
  (e: 'see-all'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isAllRead: boolean | string;
  isNotificationsEmpty: boolean | string;
};





return { __sfc: true,props, emit, MaterialIcon }
}

})